
import styles from "./ReceiptsOrder.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { Button } from 'components'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import numberToWordsRu from 'number-to-words-ru';

import userInfo from "utils/userInfo";

const ReceiptsOrder = ({ setOpenModalOrder, item }) => {
  const { t } = useTranslation('common')

    const componentRef = useRef();
    const user = userInfo();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    function numberToSomText(amount) {
        const [som, tiyin] = (amount ?? 0).toString().split(".");

        let somText = numberToWordsRu.convert(Number(som), {
            showCurrency: false,
            currency: false,
        });

        somText = somText.replace(/руб(ль|ля|лей)?/gi, "").replace(/коп(ейка|ейки|еек)?/gi, "");

        somText = somText.replace(/\b\d+\b/g, "");

        somText = somText.replace(/\s{2,}/g, " ").trim();

        somText = somText.charAt(0).toUpperCase() + somText.slice(1);

        somText = `${somText} сом`;

        const tiyinText = (tiyin ? tiyin.padEnd(2, "0") : "00");

        return `${somText} ${tiyinText} тыйын`;
    }


    return (

        <div className={`${styles.div_print_selection} unv-form-card`}>
            <div className={styles.toolbar}>
                <div className={styles.toolbarHead}>
                    <h3 className={`${styles.toolbarTitle} unv-form-card__title`}>
                        {t('auto.components_receiptsorder.k1', 'Приходный кассовый ордер')}
                    </h3>
                    <p className={`${styles.toolbarSubtitle} unv-form-card__subtitle`}>
                        {t('auto.receiptsorder.subtitle', 'Унифицированная форма КО-1 — предпросмотр для печати')}
                    </p>
                </div>
                <div className={styles.toolbarActions}>
                    <button type="button" className={`${styles.btn_print} unv-btn unv-btn--ghost`} onClick={handlePrint}>
                        {t('auto.components_academicyearcontent.k1', 'Печать')}
                    </button>
                    <Button
                        onClick={() => setOpenModalOrder(false)}
                        className={`${styles.close_btn_sub} unv-btn`}
                    >
                        {t('auto.receiptsorder.close', 'Закрыть')}
                    </Button>
                </div>
            </div>
            <div ref={componentRef} className={styles.formWrapper}>
                <div className={styles.docInfo} style={{width:"100%", justifyContent:"end"}}>
                    Унифицированная форма КО-1 Утверждена постановлением <br></br>
                    Нацстаткомитета Кыргызской Ресспублики от 07.04.2003 №4
                </div>
                <div className={styles.docInfo_header}>

                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th className={styles.table_th}></th>
                                <th>{t('auth.code')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={styles.table_th}>{t('auto.components_expensesorder.k1')}</td>
                                <td>0310001</td>
                            </tr>
                            <tr>
                                <td className={styles.table_th}>{t('auto.components_expensesorder.k2')}</td>
                                <td>05965896</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h2 className={styles.title}>{t('auto.components_receiptsorder.k1')}</h2>
                <div className={styles.docInfo_title}>
                    <div>
                        <h3 className={styles.title}>{t('auto.components_expensesorder.k4')}</h3>
                        <h4 className={styles.title}>{t('auto.components_expensesorder.k5')}</h4>
                    </div>
                    <div>
                        <h4 className={styles.title}>_____________________________</h4>
                        <h4 className={styles.title}>{t('auto.components_expensesorder.k6')}</h4>
                    </div>
                </div>
                <div className={styles.docInfo}>
                    <div>{t('auto.receiptsorder.doc_number', 'Номер документа')}: <strong>{item.order}</strong></div>
                    <div>{t('auto.receiptsorder.doc_date', 'Дата составления')}: <strong>{item.date_сreate}</strong></div>
                </div>

                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>{t('auto.components_expensesorder.k7')}</th>
                            <th>{t('auto.components_expensesorder.k8')}</th>
                            <th>{t('auto.components_expensesorder.k9')}</th>
                           <th>{t('auto.components_expensesorder.k10')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1110</td>
                            <td className={styles.table_in_td}>
                                <table className={styles.table_in}>
                                    <thead>
                                        <tr>
                                            <td>{t('auto.components_expensesorder.k11')}</td>
                                            <td>{t('auto.components_expensesorder.k12')}</td>
                                            <td>{t('auto.components_expensesorder.k13')}</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td ></td>
                                            <td>{item.check}</td>
                                            <td></td>
                                        </tr>

                                    </tbody>
                                </table>
                            </td>
                            <td>{item.amount}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>

                <div className={styles.details}>
                    <div>{t('auto.receiptsorder.received_from', 'Принято от')}: <strong>{item.source}</strong></div>
                    <div>{t('auto.receiptsorder.basis', 'Основание')}: <em>{item.check_base}</em></div>
                    <div>{t('auto.receiptsorder.amount', 'Сумма')}: <strong>{numberToSomText(item.amount)}</strong></div>
                </div>

                <div className={styles.signatures}>
                    <div className={styles.sigRow}>
                        <div>
                            {t('auto.receiptsorder.chief_accountant', 'Главный бухгалтер')}:<br />
                            <span className={styles.sigLine}></span><br />
                            <em>{user.surName} {user.firstName}</em>
                        </div>
                        <div>
                            {t('auto.receiptsorder.cashier', 'Кассир')}:<br />
                            <span className={styles.sigLine}></span><br />
                            <em>{user.surName} {user.firstName}</em>
                        </div>
                    </div>
                </div>

                <hr className={styles.divider} />

                <h2 className={styles.title}>{t('auto.components_receiptsorder.k2')}</h2>
                <div className={styles.docInfo}>
                    <div>{t('auto.receiptsorder.ko_number', '№ к/о')}: <strong>{item.order}</strong> {t('auto.receiptsorder.from', 'от')} <strong>{item.date_сreate}</strong></div>
                    <div>{t('auto.receiptsorder.accepted_from', 'Принят от')}: <strong>{item.source}</strong></div>
                </div>

                <div className={styles.details}>
                    <div>{t('auto.receiptsorder.basis', 'Основание')}: <em>{item.check_base}</em></div>
                    <div>{t('auto.receiptsorder.amount', 'Сумма')}: <strong>{item.amount}</strong></div>
                    <div>{t('auto.receiptsorder.in_words', 'Прописью')}: <strong>{numberToSomText(item.amount)}</strong></div>
                </div>

                <div className={styles.signatures}>
                    <div className={styles.sigRow}>
                        <div>
                            {t('auto.receiptsorder.stamp', 'М.П. (штамп)')} <br />
                            <span className={styles.sigLine}></span><br />
                            <em>{t('auto.receiptsorder.chief_accountant', 'Главный бухгалтер')} {user.surName} {user.firstName}</em>
                        </div>
                        <div>
                            {t('auto.receiptsorder.cashier', 'Кассир')}:<br />
                            <span className={styles.sigLine}></span><br />
                            <em>{user.surName} {user.firstName}</em>
                        </div>
                    </div>
                </div>
            </div >

          

        </div>


    );
};

export default ReceiptsOrder;
